/**
 * Determines user role based on deployment stage and URL
 * 
 * Local stage: Uses URL path (/sender or /receiver)
 * Online stage: Uses hostname (sender.domain.com or receiver.domain.com)
 */

export type UserRole = 'sender' | 'receiver' | undefined;

export const detectUserRole = (): UserRole => {
    return 'receiver';
    // const stage = import.meta.env.VITE_STAGE || 'local';
    
    // if (stage === 'online') {
    //     // Online deployment - detect by hostname
    //     const hostname = window.location.hostname;
    //     const senderUrl = import.meta.env.VITE_SENDER_URL || '';
    //     const receiverUrl = import.meta.env.VITE_RECEIVER_URL || '';
        
    //     if (hostname === senderUrl || hostname.includes('sender')) {
    //         return 'sender';
    //     }
        
    //     if (hostname === receiverUrl || hostname.includes('receiver')) {
    //         return 'receiver';
    //     }
        
    //     return undefined;
    // } else {
    //     // Local development - detect by path
    //     const path = window.location.pathname;
        
    //     if (path.startsWith('/sender')) {
    //         return 'sender';
    //     }
        
    //     if (path.startsWith('/receiver')) {
    //         return 'receiver';
    //     }
        
    //     return undefined;
    // }
};

/**
 * Get the appropriate base URL for the current deployment stage
 */
export const getBaseUrl = (): string => {
    const stage = import.meta.env.VITE_STAGE || 'local';
    
    if (stage === 'online') {
        return window.location.origin;
    } else {
        return window.location.origin;
    }
};

/**
 * Generate sender URL for sharing with receivers
 */
export const generateSenderUrl = (): string => {
    return 'https://ellington.inshare.ai';
    // const stage = import.meta.env.VITE_STAGE || 'local';
    
    // if (stage === 'online') {
    //     const senderUrl = import.meta.env.VITE_SENDER_URL || '';
    //     const protocol = window.location.protocol;
    //     return `${protocol}//${senderUrl}`;
    // } else {
    //     // return `${window.location.origin}/sender`;
    //     return `connect.inshare.ai`;
    // }
};

/**
 * Generate receiver URL for sharing
 */
export const generateReceiverUrl = (): string => {
    const stage = import.meta.env.VITE_STAGE || 'local';
    
    if (stage === 'online') {
        const receiverUrl = import.meta.env.VITE_RECEIVER_URL || '';
        const protocol = window.location.protocol;
        return `${protocol}//${receiverUrl}`;
    } else {
        return `${window.location.origin}/receiver`;
    }
};
